<div class="license-expired-page-container container">
  <p>{{ 'LICENSE_EXPIRED_MESSAGE' | translate:{ date: wizard.model.license.expirationDate | insightsDate } }}</p>
  <p>
    {{ 'CONTACT_SUPPORT_MESSAGE' | translate }}
    <a class="color-help" href="mailto:sales@retailstat.com?subject=MTN%20Insights%20License%20Renewal" target="_blank">
      sales&#64;retailstat.com
    </a>
    {{ 'CONTACT_SUPPORT_END' | translate }}
  </p>
</div>
